import React from 'react';
import MessageItem from './MessageItem';
import { getFileName, extractMessageContent, formatMessageText } from '../../utils/messageHelpers';
import { Message } from '../../types/wa_messages';

interface MessagePanelProps {
  messages: Message[];
  selectedConversation: any;
  atTop: boolean;
  atBottom: boolean;
  messagesLoading: boolean;
  messagesError: string;
  messagesTotal: number;
  loadOlderMessages: () => void;
  loadNewerMessages: () => void;
  isLoadingOlder: boolean;
  isLoadingNewer: boolean;
  messagesContainerRef: React.RefObject<HTMLDivElement | null>;
  renderMessage?: (msg: Message, idx: number) => React.ReactNode;
}

const MessagePanel: React.FC<MessagePanelProps> = ({
  messages,
  selectedConversation,
  atTop,
  atBottom,
  messagesLoading,
  messagesError,
  messagesTotal,
  loadOlderMessages,
  loadNewerMessages,
  isLoadingOlder,
  isLoadingNewer,
  messagesContainerRef,
  renderMessage,
}) => {
  // Always sort messages by timestamp ascending before rendering
  const sortedMessages = [...messages].sort(
    (a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
  );

  return (
    <div ref={messagesContainerRef} className="flex-1 overflow-y-auto px-4 py-4 relative text-left">
      {atTop && messages.length < messagesTotal && (
        <button
          className="absolute left-1/2 -translate-x-1/2 top-2 z-10 text-xs bg-slate-100 rounded px-3 py-1 mb-2 shadow hover:bg-slate-200 transition"
          onClick={loadOlderMessages}
          disabled={isLoadingOlder}
        >
          {isLoadingOlder ? 'Loading...' : 'Load older messages'}
        </button>
      )}
      {messagesLoading ? (
        <div className="text-slate-400 text-center mt-4">Loading...</div>
      ) : messagesError ? (
        <div className="text-red-500 text-center mt-4">{messagesError}</div>
      ) : messages.length === 0 ? (
        <div className="text-slate-400 text-center mt-4">No messages found for this conversation.</div>
      ) : (
        sortedMessages.map((msg, idx) =>
          renderMessage ? renderMessage(msg, idx) : <MessageItem key={msg.id} msg={msg} selectedConversation={selectedConversation} />
        )
      )}
      {atBottom && messages.length < messagesTotal && (
        <button
          className="absolute left-1/2 -translate-x-1/2 bottom-2 z-10 text-xs bg-slate-100 rounded px-3 py-1 mt-2 shadow hover:bg-slate-200 transition"
          onClick={loadNewerMessages}
          disabled={isLoadingNewer}
        >
          {isLoadingNewer ? 'Loading...' : 'Load newer messages'}
        </button>
      )}
    </div>
  );
};

export default MessagePanel; 